import { init_gradient_table, round } from 'amt_admin/utils';

const main_view = {
    template: require('./view.html'),
    controller: [
        '$scope', 'paywalls_api', 'chartFilters',
        function($scope, paywalls_api, chartFilters) {
            function set_table_data(resp) {
                $scope.vm.rows = resp.rows;
                $scope.vm.columns = resp.columns;
                const rows = resp.rows.map(row => _.pick(row, ...resp.columns));
                table.set_rows(rows);
            }
            function update_payers_table(model) {
                paywalls_api.payers_count_by_mission(model).then(set_table_data);
            }

            const table = init_gradient_table();
            $scope.get_bg_color = table.get_bg_color;
            $scope.vm = {};
            update_payers_table(chartFilters.get_chart_filters());
            chartFilters.onChangeChartParams('update_payers_table', update_payers_table);
        },
    ],
};

const state_config = {
    url: '/payers_count_by_mission',
    reloadOnSearch: false,
    data: {
        priority: 803,
        title: 'Payers Count By Mission',
        role: 'paywalls',
    },
    views: {
        '': main_view,
        'main-filter@amt.ww2': require('ww2_analytics/segments/missions_form'),
    },
};

export default state_config;
